angular.module('controllers').controller('helpController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location) {
		$rootScope.path = '/help';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'help';
		$scope.pathTemplate = 'distribution/help';
		$scope.title = 'Asistenta soferi';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'created_at';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'created_at':{'label': 'Data', 'filter': 0, 'filterType': 'input'},
			'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'select'},
			'help_content':{'label': 'Problema semnalata', 'filter': 1, 'filterType': 'input'}

		};

		$scope.search.order = 'desc';
		$scope.additionals['content_type'] = 'form-urlencoded';

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['drivers'] = data.drivers;
					$scope.columns.driver_name.options = [{id:'', value:''}];
					angular.forEach(data.drivers, function (item, key) {
						$scope.columns.driver_name.options.push({id:item.driver_name, value:item.driver_name});
					});
				});
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.maxDate = new Date();
		$scope.minDate = '2010-01-01';
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

	}]
);




